import { useMutation } from "@apollo/client";
import DEFAULT_OPERATIONS from "./comparePage.gql";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { useToasts } from "react-toast-notifications";
import { useCompare } from "../../context/CompareContext";
import { setCompareListId } from "../../features/CompareList/CompareListSlice";

export const useAddCompareList = (props = {}) => {
  const { productId } = props;
  const { addProductsToCompareList, addProductWithoutCompareList } =
    DEFAULT_OPERATIONS;
  const dispatch = useDispatch();
  const { compareListId } = useSelector((state) => state.compareListSlice);
  const { setData, data: compareData } = useCompare();

  const { addToast } = useToasts();

  const showSuccessToast = useCallback(() => {
    addToast("Item successfully added to compare list.", {
      appearance: "success",
      autoDismiss: true,
      style: {
        backgroundColor: "#027B51" /* Custom background color */,
        color: "#fff" /* Custom text color */,
      },
    });
  }, []);

  const showErrorToast = useCallback(
    (msg = "Unable to add item to compare list.") => {
      addToast(msg, {
        appearance: "error",
        autoDismiss: true,
        style: {
          backgroundColor: "#DB1F00",
          color: "#fff",
        },
      });
    },
    []
  );

  const [addProducttoCompareList, { loading, error }] = useMutation(
    addProductsToCompareList,
    {
      onCompleted: (data) => {
        if (data) {
          if (
            data &&
            data.addProductsToCompareList &&
            data.addProductsToCompareList.items
          ) {
            showSuccessToast();
            setData(data.addProductsToCompareList.items);
          }
        } else showErrorToast(error.message);
      },
      onError: (err) => {
        showErrorToast(err.message);
      },
    }
  );

  const [
    addtWithoutCompareList,
    { loading: addProductLoading, error: addProductError },
  ] = useMutation(addProductWithoutCompareList, {
    onCompleted: (data) => {
      if (data) {
        if (data && data.createCompareList && data.createCompareList.items) {
          dispatch(setCompareListId(data.createCompareList.uid));
          showSuccessToast();
          setData(data.createCompareList.items);
        }
      } else {
        showErrorToast(addProductError.message);
      }
    },
    onError: (err) => {
      showErrorToast(err.message);
    },
  });

  // const addToCompare = useCallback(() => {
  //   if (compareData.find((item) => item.product.id === productId)) {
  //     showErrorToast("Item is already added to compare");
  //   } else {
  //     addProducttoCompareList({
  //       variables: {
  //         CompareListId: compareListId,
  //         productId,
  //       },
  //     });
  //   }
  // }, [productId, compareListId]);

  function addToCompare() {
    if (compareListId) {
      if (compareData.find((item) => item.product.id === productId)) {
        showErrorToast("Item is already added to compare");
      } else {
        addProducttoCompareList({
          variables: {
            CompareListId: compareListId,
            productId,
          },
        });
      }
    } else {
      addtWithoutCompareList({
        variables: {
          products: [productId],
        },
      });
    }
  }

  return { addToCompare, loading: loading || addProductLoading };
};
